// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ExportingConfigAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { withHandlers } from 'recompose';
import { SETTINGS_KEY } from 'logic/data/Izenda.ExportConstants';
import { curry } from 'lodash/fp';

const { ORIENTATION, MARGIN, HORIZONTALLY, VERTICALLY, PAGEBREAK } = SETTINGS_KEY;

export default withHandlers({
  /**
   * change orientation settings
   * @param  {object} props 
   * @param  {int} target 
   */
  changeOrientation: curry((props: any, target: Event) => {
    props.model.updateValueByKey(parseInt(target.value), ORIENTATION);
  }),

  /**
   * change margins settings
   * @param  {object} props 
   * @param  {int} target 
   */
  changeMargins: curry((props: any, target: Event) => {
    props.validation.reset();
    props.model.updateValueByKey(parseInt(target.value), MARGIN);
  }),

  /**
   * change horizontal settings
   * @param  {object} props 
   * @param  {object} event 
   */
  changeHorizontally: curry((props: any, event: Event) => {
    props.model.updateCenterOnPageByKey(event.target.checked, HORIZONTALLY);
  }),

  /**
   * change vertical settings
   * @param  {object} props 
   * @param  {object} event 
   */
  changeVertically: curry((props: any, event: Event) => {
    props.model.updateCenterOnPageByKey(event.target.checked, VERTICALLY);
  }),

  /**
   * change page break after report part settings
   * @param  {object} props 
   * @param  {object} event 
   */
  changePageBreak: curry((props: any, event: Event) => {
    props.model.updateValueByKey(event.target.checked, PAGEBREAK);
  }),

  /**
   * change page margin configs settings
   * @param  {object} props 
   * @param  {float} value 
   */
  changeMarginConfig: curry((props: any, value: any, key: string) => {
    var marginConfig = props.model.customMarginSettings;
    marginConfig.updateValueByKey(value, key);
  })
});



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Exporting/Izenda.ExportingConfigAction.js